// @flow
import UploadFileViewModel from './upload-file';
import { default as UploadFileTemplate } from './templates/index.html';

export const COMPONENTS_UPLOAD_FILE_NAME = 'upload-file';

export const COMPONENTS_UPLOAD_FILE_ENTITIES = [
	{
		name: COMPONENTS_UPLOAD_FILE_NAME,
		entity: UploadFileViewModel,
		template: UploadFileTemplate,
	},
];
